// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { BehaviorSubject, Observable } from 'rxjs';

// --- 3rd Party
import { User as OidcUser } from 'oidc-client';

// --- HS Code
import {
  SurveyBreakModel,
  SurveyResponseModel,
  SurveyStatuses,
} from '../../../models';

// #endregion

@Injectable({
  providedIn: 'root',
})
export abstract class SurveyBreakBaseService {
  protected _contentList: SurveyBreakModel[] | null;
  get contentList(): SurveyBreakModel[] | null {
    return this._contentList;
  }

  protected _isActive$: BehaviorSubject<boolean>;
  get isActive$(): Observable<boolean> {
    return this._isActive$;
  }

  protected _activeContent$: BehaviorSubject<SurveyBreakModel | null>;
  get activeContent$(): Observable<SurveyBreakModel | null> {
    return this._activeContent$;
  }

  constructor() {
    this._activeContent$ = new BehaviorSubject<SurveyBreakModel | null>(null);
    this._isActive$ = new BehaviorSubject<boolean>(false);
    this._contentList = null;
  }

  abstract loadContent(
    identity: OidcUser,
    surveyResponse: SurveyResponseModel
  ): void;

  abstract loadBySurveyStatus(surveyStatus: SurveyStatuses): void;

  abstract loadBySurveyStatusAndGroupIndex(
    surveyResponse: SurveyResponseModel,
    groupIndex: number
  ): void;

  toggle(isActive = false): void {
    this._isActive$.next(isActive);
  }
}
